import axios from 'axios';
import Product from '@/classes/Product';
import ProductInterface from '@/interfaces/ProductInterface';

class IoProductAPI {
  static getAllWithPrices(params: Record<string, unknown>): Promise<Product[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${window.ioappConfig.ajaxUrl}`, {
        params: {
          action: 'io_products',
          endpoint: 'getAllWithPrices',
          ...params,
        },
      }).then((response) => {
        const products = [] as Product[];
        Object.values(response.data?.data?.products || {}).forEach((productAttributes) => {
          products.push(new Product(productAttributes as ProductInterface));
        });
        resolve(products);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static validateCoupon(code: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      axios.get(`${window.ioappConfig.ajaxUrl}`, {
        params: {
          action: 'io_products',
          endpoint: 'validateCoupon',
          code,
        },
      }).then((response) => {
        resolve(response?.data?.data?.valid || false);
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default IoProductAPI;
